import React from "react";
import { ArrowRight } from "lucide-react";
import { TRUST_ITEMS } from "../../data/transform";
import { openAgent } from "../../utils/openAgent";
import { AiEvolutionInfographicAnimation } from "./AiEvolutionInfographicAnimation";

export const TransformHero = () => {

  return (
    <section className="relative flex min-h-[100dvh] w-full items-center overflow-hidden" style={{ background: "#010710" }}>
      {/* Background radial glows matching /cognitive */}
      <div 
        className="pointer-events-none absolute" 
        style={{ width: 1187, height: 345, left: -238, top: -89, background: "#173862", filter: "blur(92.65px)" }} 
      />
      <div 
        className="pointer-events-none absolute right-0 top-0 h-full w-[800px] opacity-40 mix-blend-screen" 
        style={{ background: "radial-gradient(circle at right center, #0F3775 0%, transparent 60%)" }} 
      />

      <div className="relative mx-auto w-full max-w-[1440px] px-6 py-24 lg:px-[70px]">
        <div className="flex flex-col items-center gap-16 lg:flex-row lg:gap-8">
          
          {/* Left Copy matching user screenshot */}
          <div className="relative z-10 flex w-full max-w-[580px] xl:max-w-[620px] shrink-0 flex-col gap-6">
            <div className="flex flex-col gap-4">
              <p className="text-[10px] font-bold uppercase tracking-[2.5px] text-white/70">
                A NEW ERA FOR BUSINESS
              </p>
              
              <h1 className="text-[26px] sm:text-[32px] md:text-[35px] lg:text-[36px] xl:text-[40px] 2xl:text-[44px] font-bold leading-[1.15] text-white tracking-tight">
                <span className="block whitespace-nowrap">What if your software</span>
                <span className="block whitespace-nowrap">didn’t just run your business?</span>
                <span className="block whitespace-nowrap bg-gradient-to-r from-[#00D2EE] to-[#2B7BF6] bg-clip-text text-transparent mt-1">
                  What if it could think with it?
                </span>
              </h1>
            </div>
            
            <p className="text-[14.5px] leading-[25px] text-white/80 max-w-[540px]">
              <span className="block sm:whitespace-nowrap">Cognitive AI combines the power of data, models, agents and</span>
              <span className="block sm:whitespace-nowrap">your people to help your business understand, reason, act and</span>
              <span className="block sm:whitespace-nowrap">evolve — continuously creating more value.</span>
            </p>
            
            <div className="mt-2 flex">
              <button 
                onClick={openAgent} 
                className="flex items-center gap-2.5 rounded-full bg-white px-7 py-[15px] text-[14.5px] font-semibold text-[#0F172A] transition-all duration-300 hover:scale-[1.03] active:scale-95 cursor-pointer" 
                style={{ 
                  boxShadow: "0px 0px 32px 6px rgba(2, 100, 240, 0.6), 0px 2px 10px rgba(0, 50, 160, 0.4)",
                }}
              >
                <span>Discover Your AI Opportunities</span>
                <ArrowRight className="h-4 w-4" strokeWidth={2.5} />
              </button>
            </div>
          </div>

          {/* Right Image - exactly as set on /cognitive with negative left margin & violet glow */}
          <div className="relative mx-auto w-full flex-1 lg:-ml-20 xl:-ml-36">
            <div className="relative w-full min-w-0 max-w-[850px] xl:max-w-[1100px]">
              
              {/* Purple/Violet Glow */}
              <div className="pointer-events-none absolute left-1/2 top-1/2 z-0 h-[60%] w-[75%] -translate-x-1/2 -translate-y-1/2 rounded-[100%] bg-[#9333EA] opacity-40 blur-[100px]" />
              
              <div className="relative z-10 w-full scale-100 lg:scale-[1.05] xl:scale-[1.10] origin-left select-none">
                <img 
                  src="/images/cognitive/hero.png" 
                  alt="Cognitive AI Timeline" 
                  className="w-full object-contain block select-none pointer-events-none" 
                />
                {/* Futuristic Motion Graphics Overlay - perfectly aligned with underlying artwork */}
                <div className="absolute inset-0 pointer-events-none">
                  <AiEvolutionInfographicAnimation />
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export const TrustBar = () => (
  <section className="w-full bg-[#F5FAFE] border-y border-[#E2E8F0]/60 shadow-[0_4px_20px_rgba(0,0,0,0.03)]">
    <div className="mx-auto flex max-w-[1440px] flex-wrap items-center justify-center gap-x-8 gap-y-6 px-6 py-6 lg:justify-between lg:px-[68px]">
      {TRUST_ITEMS.map((it) => (
        <div key={it.title} className="flex items-center gap-[14px]">
          <img
            src={it.image}
            alt={it.title}
            className="h-[62px] w-[62px] sm:h-[66px] sm:w-[66px] object-contain flex-shrink-0 rounded-full select-none"
          />
          <div className="flex flex-col gap-[2px]">
            <span className="text-[14px] font-bold text-[#06152B]">{it.title}</span>
            <span className="text-[11.5px] font-normal text-[#51627C]">{it.sub}</span>
          </div>
        </div>
      ))}
    </div>
  </section>
);
